module.exports = __webpack_public_path__ + "img/image-2.95a85f9f.jpg";